import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=50bbccce&scoped=true"
import script from "./DashboardUtils/DashboardScript.js?vue&type=script&lang=js&external"
export * from "./DashboardUtils/DashboardScript.js?vue&type=script&lang=js&external"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=50bbccce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bbccce",
  null
  
)

export default component.exports